import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: any = ''): string {
    if (value) {
      value = value.replace(/<link[^>]*rel="stylesheet"[^>]*>/g, '');
      value = value.replace(/<script[^>]*>.*?<\/script>/g, '');
      value = this.sanitizer.bypassSecurityTrustHtml(value);
    }
    return value || '';
  }
}
